import { render, staticRenderFns } from "./OfferManager.vue?vue&type=template&id=0821beda&scoped=true&"
import script from "./OfferManager.vue?vue&type=script&lang=js&"
export * from "./OfferManager.vue?vue&type=script&lang=js&"
import style0 from "./OfferManager.vue?vue&type=style&index=0&id=0821beda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0821beda",
  null
  
)

export default component.exports